import script from "./my-textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./my-textarea.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__